// 开发环境域名

const hostDevelopment = 'https://cloud.kaopush.net'

export default {
    // 版本
    version: '2.2.1',
    baseURL: process.env.NODE_ENV === 'production' ? 'https://cloud.kaopush.net/' : hostDevelopment,
    tencentMapKey: 'FWEBZ-WHSHV-IRFPO-UNMRL-5EUWV-BFBFW'
}
